import { defineMessages } from 'react-intl'

const scope = `procurify.components.AuthenticationRequiredModal`

export default defineMessages({
  modalHeaderText: {
    id: `${scope}.modalHeaderText`,
    defaultMessage: 'Authentication required',
  },
  modalMessage: {
    id: `${scope}.modalMessage`,
    defaultMessage:
      "For your security, you're required to verify your identity before viewing sensitive transaction details.",
  },
  goBackButtonText: {
    id: `${scope}.goBackButtonText`,
    defaultMessage: 'Go back',
  },
  startAuthButtonText: {
    id: `${scope}.startAuthButtonText`,
    defaultMessage: 'Start authentication',
  },
})
